export const version = "signing-key/5.8.0";
//# sourceMappingURL=_version.js.map